'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getMargin = function getMargin(props, defaultValue) {
  var margin = props.margin,
      marginLeft = props.marginLeft,
      marginRight = props.marginRight,
      marginTop = props.marginTop,
      marginBottom = props.marginBottom,
      marginSides = props.marginSides;

  var fallbackMargin = defaultValue ? 'margin: ' + defaultValue + ';' : '';

  // apply default margin if margin is not provided
  var output = margin !== null ? 'margin: ' + margin + ';' : fallbackMargin;

  // marginSides applies margin-left and margin-right
  if (marginSides) {
    output += 'margin-left: ' + marginSides + ';margin-right: ' + marginSides + ';';
  }

  // apply other margin properties
  if (marginTop) output += 'margin-top: ' + marginTop + ';';
  if (marginBottom) output += 'margin-bottom: ' + marginBottom + ';';
  if (marginLeft) output += 'margin-left: ' + marginLeft + ';';
  if (marginRight) output += 'margin-right: ' + marginRight + ';';

  return output;
};

exports.default = getMargin;
//# sourceMappingURL=getMargin.js.map


//////////////////
// WEBPACK FOOTER
// ../container/lib/utils/getMargin.js
// module id = 262
// module chunks = 0